import { createTransformer, computedFn } from "mobx-utils";
export class BaseIndex {
    constructor(getSource, transform) {
        this.transformCached = createTransformer((entity) => this.transform(entity));
        this.getData = computedFn((key) => this.getDataCore(key, this.transformCached));
        this.getDataUncached = (key) => this.getDataCore(key, this.transform);
        this.getDataCore = (key, transform) => {
            const item = this.getSource(key);
            return item ? transform(item) : this.defaultValue;
        };
        this.getSource = getSource;
        this.transform = transform;
    }
}
//# sourceMappingURL=BaseIndex.js.map